import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

import { SearchableDropdownComponent } from './searchable-dropdown.component';

@NgModule({
    declarations: [SearchableDropdownComponent],
    imports: [CommonModule, ReactiveFormsModule, OverlayModule, PortalModule, MatIconModule, MatProgressSpinnerModule, TranslateModule],
    exports: [SearchableDropdownComponent],
})
export class SearchableDropdownModule {}
